import React from 'react';
import SectionHeader from './SectionHeader.jsx';
import Classnames from 'classnames';

export default class RepeatingSectionSimpleReview extends React.Component {
    constructor(props) {
        super(props);
    }

	renderHeader() {
		return (<SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName} sectionMessage={this.props.sectionMessage}  />);
	}

    renderSectionHeader(data, idx) {
        if (data.sectionName){
            return (
                <div key={`confirm_${idx}_header`} className="row simple-review-row">
                    <div className="col-xs-12 confirm-sub-section-heading">
                        <h5>{ data.sectionName }</h5>
                    </div>
                </div>
            );
        }
    }

    renderSectionLabel() {
        if (this.props.sectionLabel){
            return (
                <div className="row simple-review-row">
                    <div className="col-xs-12">
                        <span>{ this.props.sectionLabel }</span>
                    </div>
                </div>
            );
        }
    }

    renderItem(field, idx) {
        if (field.message) {
            return(
               <div key={`confirm_${idx}_row`} className={Classnames('row',
                        { 'simple-review-row-subsection': field.subsection },
                        { 'simple-review-row': !field.subsection })}>
                    <div className="col-xs-12">
                        <span>{ field.message }</span>
                    </div>
                </div>);
        } else {
            return (
                <div key={`confirm_${idx}_row`} className={Classnames('row',
                        { 'simple-review-row-subsection': field.subsection },
                        { 'simple-review-row': !field.subsection })}>
                    <div className="col-xs-4">
                        <span>{ field.label }</span>
                    </div>
                    <div className="col-xs-8">
                        { field.id
                        ? <span className="simple-review-value" id={field.id}>{field.value}</span>
                        : <span className="simple-review-value">{field.value}</span> }
                    </div>
                </div>);
        }
    }

    render() {
        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    {this.renderHeader()}
                    <div>
                    {
                        this.props.items.map((item, index) => {
                            return(
                                <div className={Classnames({'confirm-sub-section': index < (this.props.items.length - 1)}, this.props.sectionId)} id={this.props.sectionId + '__backFile__' + index} key={`confirm_${index}_subSection`}>
                                    {this.renderSectionHeader(item, index)}
                                    {this.renderSectionLabel()}
                                    {item.data.map(this.renderItem)}
                                </div>
                            );
                        })
                    }
                    </div>
                </div>
            </section>
        );
    }
}

RepeatingSectionSimpleReview.propTypes = {
    items: React.PropTypes.array.isRequired,
    sectionName: React.PropTypes.string.isRequired,
    sectionMessage: React.PropTypes.string,
    sectionId: React.PropTypes.string,
    sectionLabel: React.PropTypes.string
};

RepeatingSectionSimpleReview.defaultProps = {
    sectionMessage: ''
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/RepeatingSectionSimpleReview.jsx